import TimeZoneViewState from '../../store/schema/TimeZoneViewState';
import { action } from 'satcheljs';

/**
 * Action to update the timezone view state in the event of a change
 * @param newViewState : The set of properties changed
 */
const updateTimeZoneViewState = action('updateTimeZoneViewState', (changes: TimeZoneViewState) => ({
    changes,
}));

export default updateTimeZoneViewState;
